import { configureStore } from "@reduxjs/toolkit";
import sortSliceReducer from "./slices/sortSlice";
import searchSliceReducer from "./slices/SearchSlice";
export const store = configureStore({
  reducer: {
    sort: sortSliceReducer,
    search: searchSliceReducer,
  },
});
